import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PropertyPresetsService, PropertyPreset } from './property-presets.service';
import { BuilderNode, BuilderComponentType } from '../interfaces/builder-screen.models';
import { BuilderScreenBetaService } from '../services/builder-screen.service';

@Component({
  selector: 'app-property-presets-modal',
  templateUrl: './property-presets-modal.component.html',
  styleUrls: ['./property-presets-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PropertyPresetsModalComponent implements OnInit, OnDestroy {
  @Input() visible = false;
  @Input() componentType: BuilderComponentType | null = null;
  @Input() selectedNode: BuilderNode | null = null;
  
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() presetApplied = new EventEmitter<PropertyPreset>();

  private readonly destroy$ = new Subject<void>();
  
  presets$: Observable<PropertyPreset[]>;
  selectedPreset: PropertyPreset | null = null;

  constructor(
    private readonly presetsService: PropertyPresetsService,
    private readonly builderService: BuilderScreenBetaService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.presets$ = this.presetsService.getPresetsForComponent(this.componentType || 'text');
  }

  ngOnInit() {
    // Atualiza presets quando tipo de componente muda
    if (this.componentType) {
      this.presets$ = this.presetsService.getPresetsForComponent(this.componentType);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  show() {
    this.visible = true;
    this.visibleChange.emit(this.visible);
    this.cdr.markForCheck();
  }

  onClose() {
    this.visible = false;
    this.selectedPreset = null;
    this.visibleChange.emit(this.visible);
    this.cdr.markForCheck();
  }

  selectPreset(preset: PropertyPreset) {
    this.selectedPreset = preset;
    this.cdr.markForCheck();
  }

  applyPreset() {
    if (this.selectedPreset && this.selectedNode) {
      // Aplica propriedades do preset ao nó selecionado
      const appliedPreset = this.presetsService.applyPreset(this.selectedPreset.id);
      if (appliedPreset) {
        this.presetApplied.emit(appliedPreset);
        this.onClose();
      }
    }
  }

  createPresetFromCurrent() {
    if (this.selectedNode) {
      const presetName = `Custom ${this.selectedNode.type}`;
      const presetDescription = `Custom preset for ${this.selectedNode.type} component`;
      this.presetsService.createCustomPreset(
        presetName, 
        presetDescription,
        this.selectedNode.type, 
        this.selectedNode.props || {}
      );
      
      // Atualiza lista de presets
      this.presets$ = this.presetsService.getPresetsForComponent(this.componentType || 'text');
      this.cdr.markForCheck();
    }
  }

  trackByPresetId(index: number, preset: PropertyPreset): string {
    return preset.id;
  }
}
